import { AuthModals } from "@features/accounts/auth-modals"
import { useAuth } from "@features/accounts/useAuth"
import { FlyingCarpet } from "@features/flying-carpet/FlyingCarpet"
import { SquadupModal } from "@features/ticketing/SquadUpModal"
import { AlertSystem } from "@utils/alerts"
import { ContentBlocks } from "eddev/blocks"
import { ScrollRestoration, useRouterEvents } from "eddev/routing"
import { defineView } from "eddev/views"
import { useEffect } from "react"
import { Analytics } from "@vercel/analytics/react"

export default defineView("_app", (props) => {
  if (env.client) {
    useAuth()
  }

  useRouterEvents((event) => {
    if (event.type === "clicked" && event.mode === "ignore" && event.isSameUrl)
      document.scrollingElement?.scrollTo({
        top: 0,
        behavior: "smooth",
      })
  })

  return (
    <>
      {!env.dev && <Analytics />}
      <ScrollRestoration />
      <ContentBlocks blocks={props.templateParts?.siteHeader?.contentBlocks} />
      <FlyingCarpet />
      <div className="page-content">{props.children}</div>
      {/* Squadup modal view */}
      <SquadupModal />
      {/* General alerts system */}
      <AlertSystem />
      {/* Modals used by the user system */}
      <AuthModals />
    </>
  )
})
